export default __webpack_public_path__ + "static/media/photo--sm--85.e0a9820c.jpg";